<template>
    <component :is="isLoginPage"></component>
</template>
<script>
/* eslint-disable */
import Login from "./components/Login"
import LoginMain from "./components/LoginMain"
import Principal from "./components/Principal"
import Register from "./components/completeRegister"
import Servers from "../server.js";
import { mapState, mapGetters } from 'vuex'

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbBtn,
  mdbIcon,
  mdbView,
  mdbMask,
} from "mdbvue";
import resetPasswordVue from './components/resetPassword.vue'

export default {
  name: "MyFracv2",
  components: {
    Login,
    Principal,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask,
  },
  data() {
    return {
     

    };
  },
  computed:{
    ...mapGetters({"isLogin":"getAuthenticated"}),
    isLoginPage() {
      // if(localStorage.getItem("access_token") == null)
      //     localStorage.setItem("access_token", this.$route.query.token) // COMENTAR PARA  DEV
          
      if(this.$route.query.type === undefined){
         if (localStorage.getItem("access_token")){
          
          return Principal
        }
        else if(this.$route.name==="restablecer contraseña") {
          return resetPasswordVue
        } else {
          return LoginMain;
        }
      }else if (this.$route.query.type.includes("contractor")) {
        //localStorage.clear();
        return Login;
      } else if(this.$route.query.type.includes("register")){
        //localStorage.clear();
        return Register
      } else if(this.$route.name==="restablecer contraseña") {
          return resetPasswordVue
        } else {
          localStorage.setItem("role", this.$route.query.type);
          //return Principal;
          return LoginMain;
        }
    },
  },
  mounted() {
    this.$moment.locale("es");
 
  },
  updated() {
  
  },
  methods: {

    
  }
};
</script>

<style scoped>

</style>

 <style>
@font-face {
  font-family: "OpenSans-Regular";
  font-weight: normal;
  font-style: normal;
  src: url("../static/fonts/OpenSans-Regular.ttf");
}
@font-face {
  font-family: "OpenSans-Bold";
  font-weight: normal;
  font-style: normal;
  src: url("../static/fonts/OpenSans-Bold.ttf");
}
@font-face {
  font-family: "OpenSans-Semibold";
  font-weight: normal;
  font-style: normal;
  src: url("../static/fonts/OpenSans-SemiBold.ttf");
}

@font-face {
  font-family: Poppins-Regular;
  src: url("../static/fonts/Poppins-Regular.ttf");
}

@font-face {
  font-family: Poppins-Bold;
  src: url("../static/fonts/Poppins-Bold.ttf");
}

@font-face {
  font-family: Poppins-Medium;
  src: url("../static/fonts/Poppins-Medium.ttf");
}

@font-face {
  font-family: Montserrat-Bold;
  src: url("../static/fonts/Montserrat-Bold.ttf");
}

.btn-outline-white:hover, .btn-outline-white:focus, .btn-outline-white:active, .btn-outline-white:active:focus, .btn-outline-white.active {
    border-color: #fff !important;
    background-color: #67a3cf !important;
    color: #fff !important;
}
</style>